var map = {
	"./affaere1/favourite-green-button.svg": 48253,
	"./affaerentreff/favourite-green-button.svg": 52299,
	"./casualxdates/favourite-green-button.svg": 19910,
	"./favourite-green-button.svg": 48215,
	"./ficktreffpunkt24/favourite-green-button.svg": 32240,
	"./fremdgehboerse/favourite-green-button.svg": 7432,
	"./illicitoasis/favourite-green-button.svg": 98205,
	"./seitensprungtreff69/favourite-green-button.svg": 45381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56651;